// Add your custom JS here.script>

//Gallery swiper

const gallerySetup = () => {
  const gallerySwiper = document.getElementsByClassName("gallery-swiper");
  if (gallerySwiper.length > 0) {
    [...gallerySwiper].forEach((gallery, index) => {
      gallery.classList.add(`swiper-${index}`);
      console.log(gallery);
      new Swiper(`.swiper-${index}`, {
        slidesPerView: "auto",
        spaceBetween: 10,
        effect: "fade",
        loop: true,
        autoHeight: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    });
  } else {
    return;
  }
};
//Trust mark swiper
const trustmarkSetup = () => {
  var swiper = new Swiper(".trustmarks", {
    slidesPerView: 2,
    spaceBetween: 100,
    autoplay: true,
    loop: true,
    allowTouchMove: false,
    speed: 2000,
    freeMode: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      420: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 40,
      },
    },
  });
  if (document.querySelector(".trustmarks")) {
    document.querySelector(".trustmarks").classList.add("loaded");
  }
};

// mobile Menus

const navIcons = document.getElementById("nav-icon1");
const navMenu = document.querySelector(".burger-menu");

const burgerMenu = () => {
  const mobMenu = document.querySelector(".mobile-menu");
  document.querySelectorAll(".burger").forEach(function (icon) {
    icon.classList.toggle("open");
  });
  mobMenu.classList.toggle("open");
};

navIcons.addEventListener("click", function () {
  burgerMenu();
});
navMenu.addEventListener("click", function () {
  burgerMenu();
});

//playlist audio function

const list = document.querySelectorAll("#list li a");
function musicSwitchFunc(list) {
  list.forEach(function (item) {
    item.addEventListener("click", function (e) {
      e.preventDefault();
      let elm = e.target;
      console.log(elm);
      let audio = document.getElementById("audio");
      let source = document.getElementById("audioSource");
      let artist = document.getElementById("artist");
      let song = document.getElementById("song");
      let album = document.getElementById("album");
      source.src = elm.getAttribute("data-value");
      artist.innerHTML = elm.getAttribute("data-artist");
      song.innerHTML = elm.getAttribute("data-song");
      album.src = elm.getAttribute("data-album");
      audio.load();
      audio.play();
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  gallerySetup();
  trustmarkSetup();
  musicSwitchFunc(list);
});

// keep track of previous scroll position
let prevScrollPos = window.scrollY;

window.addEventListener("scroll", function () {
  const currentScrollPos = window.scrollY;

  if (currentScrollPos > 100) {
    document.querySelector("header").classList.add("fixed");
    document.querySelector("header").classList.add("bg-white-added");
    document.querySelector("#nav-icon1").classList.add("switch-to-black");
    if (prevScrollPos > currentScrollPos) {
      document.querySelector("header").classList.add("show");
    } else {
      document.querySelector("header").classList.remove("show");
    }
  } else {
    document.querySelector("header").classList.remove("fixed");
    document.querySelector("header").classList.remove("bg-white-added");
    document.querySelector("header").classList.add("show");
    document.querySelector("#nav-icon1").classList.remove("switch-to-black");
  }

  // update previous scroll position
  prevScrollPos = currentScrollPos;
});

// load AOS
AOS.init();
